import { post } from './request'

export function toLogin (data) {
  return post('/api/login', data)
}

export function tSelectObject (data) {
  return post('/api/selectObject', data)
}

export function tChangeObject (data) {
  return post('/api/changeObject', data)
}

export function tHandleQuery (data) {
  return post('/api/handleQuery', data)
}

export function tSendNewText (data) {
  return post('/api/sendnewtext', data)
}

export function tGenIntentRecog (data) {
  return post('/api/genIntentRecog', data)
}

export function tSaveConvers (data) {
  return post('/api/saveconvers', data)
}

export function tSaveMessage (data) {
  return post('/api/savemessage', data)
}

export function tUpdateConvers (data) {
  return post('/api/updateconvers', data)
}

export function tLoadConversList (data) {
  return post('/api/loadconverslist', data)
}

export function tLoadConversDetail (data) {
  return post('/api/loadconversdetail', data)
}

export function tReportSaleOrder (data) {
  return post('/api/reportSaleOrder', data)
}

export function tLoadAnalyticList (data) {
  return post('/api/loadanalyticlist', data)
}

export function tLoadAnalyticData (data) {
  return post('/api/loadAnalyticData', data)
}

export function tLoadOrOptions (data) {
  return post('/api/loadOrOptions', data)
}

export function tLoadSqlOptions (data) {
  return post('/api/loadSqlOptions', data)
}

export function tLoadParts (data) {
  return post('/api/loadParts', data)
}

export function tLoadReports (data) {
  return post('/api/loadReports', data)
}

export function tWechatUserid (data) {
  return post('/api/wechat/wechatuserid', data)
}

export function tWechatUserinfo (data) {
  return post('/api/wechat/wechatuserinfo', data)
}

export function tNewEval (data) {
  return post('/api/newEval', data)
}

export function tEasyaisSelect (data) {
  return post('/api/easyaisSelect', data)
}

export function tEasyaisSearch (data) {
  return post('/api/easyaisSearch', data)
}

export function tExportPPT(data) {
  return post('/api/exportPPT', data)
}

export function tLoadLookups(data) {
  return post('/api/loadLookups', data)
}

export function tNewScanOrder(data) {
  return post('/api/newScanOrder', data)
}

export function tLoadScanNoList(data) {
  return post('/api/loadScanNoList', data)
}

export function tLoadScanDetail(data) {
  return post('/api/loadScanDetail', data)
}

export function tEasyaisInventory(data) {
  return post('/api/easyaisInventory', data)
}

export function tAddScanDetail(data) {
  return post('/api/addScanDetail', data)
}

export function tUpdateScanDetail(data) {
  return post('/api/updateScanDetail', data)
}

export function tEasyaisInOutStock(data) {
  return post('/api/easyaisInOutStock', data)
}


